import { render } from "./DeferredMount.vue?vue&type=template&id=14bbc604"
import script from "./DeferredMount.vue?vue&type=script&lang=js"
export * from "./DeferredMount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__